/**
 * A set of arrays used to populate options for a select tag.
 *
 * The value of the "label" key is used to identify the option within
 * the select dropdown as well as when chosen as the selected option.
 *
 * The value of the "value" key is used when processing the form or
 * URL search query parameters.
 */
const mdeTypeOptions = [
  {
    "label": 'All types',
    "value": 'All'
  },
  {
    "label": 'Exhibition',
    "value": 'Exhibition'
  },
  {
    "label": 'Film Series',
    "value": 'FilmSeries'
  },
  {
    "label": 'Performance Series',
    "value": 'PerformanceSeries'
  },
  {
    "label": 'Collection galleries',
    "value": 'Theme'
  },
  {
    "label": 'Installations',
    "value": 'Other'
  },
];

const currentYearStr = new Date().getFullYear().toString();

const timeSpanOptions = [
  {
    "label": 'All Years',
    "value": 'all',
    "begin_date": '1929',
    "end_date": 'now',
  },
  {
    "label": 'Current Year',
    "value": 'current',
    "begin_date": currentYearStr,
    "end_date": currentYearStr,
  },
];

const decadeSpanOptions = [
  {
    "label": '1920s',
    "value": '1920',
    "begin_date": '1920',
    "end_date": '1929',
  },
  {
    "label": '1930s',
    "value": '1930',
    "begin_date": '1930',
    "end_date": '1939',
  },
  {
    "label": '1940s',
    "value": '1940',
    "begin_date": '1940',
    "end_date": '1949',
  },
  {
    "label": '1950s',
    "value": '1950',
    "begin_date": '1950',
    "end_date": '1959',
  },
  {
    "label": '1960s',
    "value": '1960',
    "begin_date": '1960',
    "end_date": '1969',
  },
  {
    "label": '1970s',
    "value": '1970',
    "begin_date": '1970',
    "end_date": '1979',
  },
  {
    "label": '1980s',
    "value": '1980',
    "begin_date": '1980',
    "end_date": '1989',
  },
  {
    "label": '1990s',
    "value": '1990',
    "begin_date": '1990',
    "end_date": '1999',
  },
  {
    "label": '2000s',
    "value": '2000',
    "begin_date": '2000',
    "end_date": '2009',
  },
  {
    "label": '2010s',
    "value": '2010',
    "begin_date": '2010',
    "end_date": '2019',
  },
  {
    "label": '2020s',
    "value": '2020',
    "begin_date": '2020',
    "end_date": '2029',
  },
];

const dateSpanOptions = [
  ...timeSpanOptions,
  ...decadeSpanOptions
];

const locationOptions = [
  {
    "label": 'All locations',
    "value": 'both'
  },
  {
    "label": 'MoMA',
    "value": 'moma'
  },
  {
    "label": 'MoMA PS1',
    "value": 'ps1'
  },
];

const sortDateOptions = [
  {
    "label": 'Relevance',
    "value": 'relevance'
  },
  {
    "label": 'Chronological',
    "value": 'ascending'
  },
  {
    "label": 'Reverse-chronological',
    "value": 'descending'
  },
];

/**
 * The default parameters for the collection form.
 */
const defaultParams = {
  begin_date: timeSpanOptions[0].begin_date, // 1929
  constituent_id: -1,                        // -1
  end_date: timeSpanOptions[0].end_date,     // now
  location: locationOptions[0].value,        // both
  mde_type: mdeTypeOptions[0].value,         // All
  q: '',                                     // ''
  sort_date: sortDateOptions[0].value,       // relevance
};

export const options = {
  dateSpanOptions,
  defaultParams,
  locationOptions,
  mdeTypeOptions,
  sortDateOptions
};
